import {ICON_OPTIONS} from './buttonIcons';

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[char]);
}

function getButtonStyles(settings) {
  const background = settings.gradient
    ? `linear-gradient(${settings.gradientDirection},${settings.gradientStart},${settings.gradientEnd})`
    : settings.backgroundColor;
  const border = settings.borderWidth
    ? `${settings.borderWidth}px ${settings.borderStyle} ${settings.borderColor}`
    : 'none';

  return [
    'display: inline-flex',
    'align-items: center',
    'justify-content: center',
    'gap: 10px',
    'text-decoration: none',
    `background: ${background}`,
    `color: ${settings.textColor}`,
    'font-family: inherit',
    'font-size: inherit',
    `border-radius: ${settings.borderRadius}px`,
    `padding: ${settings.paddingVertical}px ${settings.paddingHorizontal}px`,
    `font-weight: ${settings.bold ? '700' : 'inherit'}`,
    `font-style: ${settings.italic ? 'italic' : 'inherit'}`,
    `border: ${border}`,
    'text-align: center',
    'line-height: 1.2',
    'transition: transform 180ms ease,box-shadow 180ms ease,filter 180ms ease',
  ];
}

const hoverCss = {
  lift: 'transform: translateY(-3px);box-shadow: 0 8px 18px rgba(0,27,33,.25);',
  grow: 'transform: scale(1.04);',
  glow: 'box-shadow: 0 0 0 4px rgba(56,211,159,.25),0 0 18px rgba(56,211,159,.45);',
  brighten: 'filter: brightness(1.1);',
  nudge: 'transform: translateX(3px);',
};

const previewStyles = {
  lift: {transform: 'translateY(-3px)', boxShadow: '0 8px 18px rgba(0,27,33,.25)'},
  grow: {transform: 'scale(1.04)'},
  glow: {boxShadow: '0 0 0 4px rgba(56,211,159,.25),0 0 18px rgba(56,211,159,.45)'},
  brighten: {filter: 'brightness(1.1)'},
  nudge: {transform: 'translateX(3px)'},
};

export function getHoverPreviewStyle(effect, isHovered) {
  return isHovered ? previewStyles[effect] || {} : {};
}

function getIconMarkup(settings) {
  const icon = ICON_OPTIONS.find((option) => option.value === settings.icon);
  return icon ? `<i class="fas ${icon.value}" aria-hidden="true"></i>` : '';
}

function getButtonContent(settings) {
  const label = `<span>${escapeHtml(settings.label || 'Click Here')}</span>`;
  const icon = getIconMarkup(settings);

  return settings.iconPosition === 'left' ? `${icon}${label}` : `${label}${icon}`;
}

function getLinkAttributes(url, openInNewTab) {
  const target = openInNewTab ? ' target="_blank" rel="noopener noreferrer"' : '';
  return `href="${escapeHtml(url)}"${target}`;
}

export function createButtonCode(settings, mode, openInNewTab) {
  const styles = getButtonStyles(settings);
  const url = settings.url || 'https://example.com';
  const linkAttributes = getLinkAttributes(url, openInNewTab);
  const content = getButtonContent(settings);

  if (mode === 'html-css') {
    const declarations = styles.map((style) => ` ${style};`).join('\n');
    const hoverRule = hoverCss[settings.hoverEffect]
      ? `\n.button-link:hover {\n ${hoverCss[settings.hoverEffect]}\n}`
      : '';

    return `<style> .button-link {${declarations}}${hoverRule} </style> <a ${linkAttributes} class="button-link">${content}</a>`;
  }

  return `<a ${linkAttributes} style="${styles.join(';')};">${content}</a>`;
}